import OutlinedInput from '@mui/material/OutlinedInput';

export default function Text(props) {
  const handleOnChange = ({ target }) => {
    props.onChange({ name: target.name, value: target.value });
  };

  return <OutlinedInput {...props} onChange={handleOnChange} />;
}
